import React, { memo, useState } from 'react';
import { Header } from '../../components/layout/header';
import { ValuationCustomForm } from '../../components/valuation/custom';
import { useParams } from 'react-router-dom';
import { AdditionalForm } from '../../components/valuation/additional';
import { ValuationApi } from '../../apis';

type Props = {
  id: string;
};

// engineTransmissionCondition: undefined,
// warningLightCondition: undefined,
// windowCondition: undefined,
// lightCondition: undefined,
// scratchNote: undefined,
// accidentNote: undefined,
// saloonCondition: undefined,
// saloonImageId: undefined,
// odo: undefined,
// odoImageId: undefined,
// hoodNote: undefined,
// hoodImageId: undefined,
// frontImageId: undefined,
// backImageId: undefined,
// rightImageId: undefined,
// leftImageId: undefined,

const ValuationEditScreen = memo(() => {
  const { id } = useParams() as Props;
  const [payload, setPayload] = useState<any>({
    valuateType: 'CUSTOM',
    registerNo: undefined,
    fullName: undefined,
    odo: undefined,
    carBrandId: undefined,
    carModelId: undefined,
    engineCapacity: undefined,
    transmission: undefined,
    condition: undefined,
    steering: undefined,
    engineType: undefined,
    drivetrain: undefined,
    exteriorColor: undefined,
    interiorColor: undefined,
    manufacturedYear: undefined,
    importedYear: undefined,
    price: undefined,
    plateNumber: undefined,
    optionId: undefined,
  });

  const [action, setAction] = useState<{
    loading: boolean;
    payload: any;
    found?: 'ADDITIONAL_DATA' | 'IS_ADDITIONAL_DATA' | boolean; // undefined, null, boolean, string
  }>({
    loading: false,
    payload: undefined,
    found: undefined,
  });

  React.useEffect(() => {
    const reload = async () => {
      const res = await ValuationApi.get(id);
      setPayload({
        valuateType: 'CUSTOM',
        registerNo: res?.valuationUser?.registerNo,
        fullName: res?.valuationUser?.fullName,
        odo: res?.odo,
        carBrandId: res?.carBrandId,
        carModelId: res?.carModelId,

        engineCapacity: res?.vehicle?.engineCapacity,
        transmission: res?.vehicle?.transmission,
        condition: res?.vehicle?.condition,
        steering: res?.vehicle?.steering,
        engineType: res?.vehicle?.engineType,
        drivetrain: res?.vehicle?.drivetrain,
        exteriorColor: res?.vehicle?.exteriorColor,
        interiorColor: res?.vehicle?.interiorColor,
        manufacturedYear: res?.vehicle?.manufacturedYear,
        importedYear: res?.vehicle?.importedYear,
        price: res?.vehicle?.price,
        plateNumber: res?.vehicle?.plateNumber,
        optionId: res?.vehicle?.optionId,
        // additional
        engineTransmissionCondition: res?.engineTransmissionCondition,
        warningLightCondition: res?.warningLightCondition,
        windowCondition: res?.windowCondition,
        lightCondition: res?.lightCondition,
        scratchNote: res?.scratchNote,
        accidentNote: res?.accidentNote,
        saloonCondition: res?.saloonCondition,
        hoodNote: res?.hoodNote,
        // images
        saloonImageId: res?.saloonImage.id,
        odoImageId: res?.odoImage.id,
        hoodImageId: res?.hoodImage.id,
        frontImageId: res?.frontImage.id,
        backImageId: res?.backImage.id,
        rightImageId: res?.rightImage.id,
        leftImageId: res?.leftImage.id,
      });
    };

    reload();

    return () => {
      setPayload(undefined);
    };
  }, [id, payload?.valuationUser?.firstName]);

  if (!payload) {
    return <div></div>;
  }

  console.log('payload :', payload);

  return (
    <>
      <div className="flex-col bg-white rounded-[8px] p-5">
        <Header title="Үнэлгээ хийх" isGoBack={true} />
        <div className="flex flex-row w-full">
          <ValuationCustomForm setAction={setAction} payload={payload} />
          <div className="w-[40px]" />
          <AdditionalForm
            action={{
              ...action,
              payload: {
                id: id,
              },
            }}
            payload={payload}
          />
        </div>
      </div>
    </>
  );
});

ValuationEditScreen.displayName = 'ValuationEditScreen';

export { ValuationEditScreen };
